export const predialTypes = [
  { title: "Opción 1: Predial del imbueble" },
  { title: "Opción 2: Escrituras del inmueble" },
];

export const labelPredialOptions: any = {
  predial: {
    collateral: "el predial (del año en curso) del inmueble en garantía.",
    property:
      "el predial (del año en curso) del inmueble en renta a nombre del propietario",
  },
  scriptures: {
    collateral:
      "las escrituras o predial (del año en curso) del inmueble en garantía.",
    property:
      "las escrituras o predial (del año en curso) del inmueble en renta a nombre del propietario",
  },
};
